import { useState } from "react";
import { useSelector } from "react-redux";
import { convert_to_currency_with_unit } from "../../App/validation/convert_to_currency_with_unit";
// import AddonFeatureSlider from './AddonFeatureSlider';
import AddonFeatureChecklist from "./AddonFeatureChecklist";
import {
  Add,
  Remove,
  CheckCircle,
  KeyboardArrowDown,
  InfoOutlined,
} from "@material-ui/icons";
import { Switch } from "@mui/material";

function PricingCard(params) {
  const {
    package_type,
    is_active = false,
    title,
    subtitle,
    extra_title,
    no_discount,

    price,
    currency,
    unit,
    free_trial,

    settings = [], // labels, value,
    duration,

    // is_collab,

    included_licenses = [],
    notes,
    button,

    set_package_selected,
    trial_banner,
    is_ever_purchase
  } = params;

  const { license_features } = useSelector((state) => {
    return {
      license_features: state.payment.license_features_2025,
    };
  });

  const handle_license = () => {
    const license_features_state = {};
    included_licenses.forEach((item) => {
      license_features_state[item] = false;
    });
    return license_features_state;
  };

  const [feature_drowdown, set_feature_dropdown] = useState(() =>
    handle_license()
  );

  const handle_features = (license_name) => {
    set_feature_dropdown({
      ...feature_drowdown,
      [license_name]: !feature_drowdown[license_name],
    });
  };

  const sliders = settings.filter((item) => item.type === "slider");
  const counters = settings.filter((item) => item.type === "counter");

  return (
    <div
      className={`card_license gap_10 ${is_active ? "active_card" : ""}`}
      onMouseEnter={() => set_package_selected(package_type)}
    // onClick={() => set_package_selected(package_type)}
    >
      <section className="flex flex_col">
        <label className="font_18 bold">{title}</label>
        <label>{subtitle}</label>
        <label className="font_14">{extra_title}</label>
      </section>


      <section>
        {no_discount && (
          <section style={{ color: "#D10000" }}>
            <label style={{ fontSize: "12px", textDecoration: "line-through" }}>
              {convert_to_currency_with_unit({ currency, value: no_discount })}
              {unit ? "/" : ""}
              {unit}
            </label>
          </section>
        )}
        {price && (
          <section>
            <label style={{ fontSize: "25px" }}>
              {convert_to_currency_with_unit({ currency, value: price })}
            </label>
            <label>{unit ? "/" : ""}</label>
            <label>{unit}</label>
          </section>
        )}
        {free_trial && (
          <section style={{ color: "green" }}>
            <label style={{ fontSize: "12px" }}>
              {free_trial}
            </label>
          </section>
        )}

      </section>

      <section className="flex flex_col gap_15">
        {license_features
          .filter((item) => included_licenses.includes(item.key))
          .map((feature, idx) => (
            <div key={idx} className="flex flex_col gap_5">
              <div
                className="pointer"
                onClick={() => handle_features(feature.key)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <label className="underline pointer">
                  {feature?.name?.ina || feature?.name?.eng}
                </label>
                {
                  <KeyboardArrowDown
                    style={{
                      transform: feature_drowdown[feature?.key]
                        ? "rotate(180deg)"
                        : "rotate(0deg)",
                    }}
                  />
                }
              </div>
              {feature_drowdown[feature.key] &&
                feature["subfeatures"].map(
                  ({ eng, ina, subfeature_name }, sub_idx) => (
                    <div key={sub_idx} className="flex align_center gap_5">
                      <CheckCircle
                        style={{ color: is_active ? "#000000" : "#ababab", outline: "none" }}
                        fontSize="small"
                      />
                      {eng}
                    </div>
                  )
                )}
            </div>
          ))}
      </section>

      {notes && (
        <section className="flex flex_col gap_15">
          <div className="flex flex_col gap_5">
            <label className="underline">{notes.header}</label>
            <label className="font_12">{notes.body}</label>
            <label className="font_12">{notes.footer}</label>
          </div>
        </section>
      )}

      {counters?.length > 0 && (
        <section>
          {counters.map((item, idx) => (
            <div key={idx}>
              <label className="underline">{item.header}</label>
              <div className="flex align_center gap_5">
                <button onClick={() => item?.onChange("-")}>
                  {" "}
                  <Remove />
                </button>
                <div className="w_50 noborder text_center">{item.value}</div>
                <button onClick={() => item?.onChange("+")}>
                  <Add />
                </button>
                <label className="marginLeft_5">{item.unit}</label>
                <div className="tooltip center_perfect" data-tooltip={`1 creator, ${item.value - 1} member`}>
                  <InfoOutlined style={{ fontSize: "16px" }} />
                </div>
              </div>
            </div>
          ))}
        </section>
      )}

      {duration && (
        <section>
          <label className="underline">{duration?.header}</label>
          <div className="flex align_center">
            <label>1</label>
            <Switch
              sx={{
                "& .MuiSwitch-switchBase.Mui-checked": {
                  color: "#000",
                },
                "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                  backgroundColor: "#000",
                },
              }}
              checked={duration?.month === 12 ? true : false}
              onChange={() => {
                duration?.onChange(package_type);
              }}
              inputProps={{ "aria-label": "controlled" }}
            />
            <label>12</label>
            <label className="marginLeft_10">
              month{duration?.month === 12 ? "s" : ""}
            </label>
          </div>
        </section>
      )}

      {trial_banner && (
        <section>
          <h5 style={{ fontSize: "14px" }}>{trial_banner}</h5>
        </section>
      )}

      <section>
        {sliders.map((item, idx) => (
          <AddonFeatureChecklist
            key={idx}
            is_active={is_active}
            value={item.value}
            labels={item.labels}
            onChange={(e) => {
              item?.onChange(e);
              handle_license(e);
            }}
            month={duration?.month}
            is_ever_purchase={is_ever_purchase}
            license_features={license_features}
            currency={currency}
          />
        ))}
      </section>

      <button
        onClick={() => button?.onSubmit()}
        className="border marginTop_auto"
      >
        {button?.text}
      </button>
    </div>
  );
}

export default PricingCard;
